// src/msalOnboardConfig.js
import { PublicClientApplication } from "@azure/msal-browser";

export const msalOnboardInstance = new PublicClientApplication({
  auth: {
    clientId: "9d4e9287-a121-4937-b94d-e7be78d8d334",  // <-- Replace with real App ID
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin + "/tenant-baseline-options"
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
});
